/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Type } from '@app/settings/types/types.model';
import { TypesFormComponent } from '@app/settings/types/types-form/types-form.component';

@Injectable({
  providedIn: 'root',
})
export class TypesFormService {
  constructor(private modalService: NgbModal) {}

  /**
   * Open Type Form
   * @param type dialog data
   */
  public open(type: null | Type = null) {
    const modal = this.modalService.open(TypesFormComponent);
    modal.componentInstance.type = type;
    return modal.result;
  }
}
